import { ApiError } from "../../api/errors";

/** A failed theme call, in words an operator can act on. */
export function describeError(e: unknown, action: "manage" | "delete" = "manage"): { title: string; detail: string } {
  if (e instanceof ApiError) {
    if (e.kind === "forbidden") {
      return action === "delete"
        ? { title: "Your role cannot delete portal themes", detail: "Deleting a theme needs the delete permission on portal themes for this namespace." }
        : { title: "Your role cannot manage portal themes", detail: "Portal themes need the Operator role on this namespace." };
    }
    if (e.kind === "unavailable") return { title: "The theme service is not available right now", detail: e.message };
    return { title: "The request was refused", detail: e.message };
  }
  return { title: "Something went wrong", detail: e instanceof Error ? e.message : String(e) };
}
